module.exports = __webpack_public_path__ + "static/media/video_not_available.b849c57f.png";